import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import { Box, Typography } from '@material-ui/core'
import { vppService } from '../../Services'
import { ERROR, SUCCESS } from '../../utils/messageTypes'
import DisplayMessage from '../../Components/DisplayMessage'
import * as MessageType from '../../Constants/MessagesConstant'
import { Breadcrumb, AppButton, Loader } from '../../Components'
import { Cards, OutlinedButton, Popup } from '../../elements'
import { useStyles } from './style'
import VppForm from './vppForm'
import { forwardTo } from '../../utils/helper'
import Error404 from '../ErrorPages/Error404'

function CreateVpp(props) {
  const classes = useStyles()
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState('')
  const [messageType, setMessageType] = useState('')
  const [vppId, setVppId] = useState('')
  const [isEdit, setEditFlow] = useState(false)
  const [vppDetails, setVppDetails] = useState({})
  const [showPopup, setPopup] = useState(false)
  const [loading, setLoading] = useState(false)
  const [programId, setProgramId] = useState('')
  const [notFound, setNotFound] = useState(false)

  useEffect(() => {
    const id = _.get(props.match.params, 'vpp', '')
    const progId = _.get(props.match.params, 'programs_id', '')
    setProgramId(progId)
    setVppId(id)
    setEditFlow(id ? true : false)
    if (!(props.isViewOnly || props.isAdmin)) {
      progId ? forwardTo(`/programs/${progId}/vpp`) : forwardTo('/vpp')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isAdmin, props.match.params, props.isViewOnly])

  const errorCb = (message) => {
    setOpen(true)
    setMessageType(ERROR)
    setMessage(message)
    setLoading(false)
  }

  const successCb = (isDelete) => {
    setLoading(false)
    props.history.replace({
      pathname: programId ? `/programs/${programId}/vpp` : '/vpp',
      showMessage: true,
      message: isDelete
        ? 'Successfully removed virtual power plant'
        : isEdit
          ? 'Successfully updated virtual power plant'
          : 'Successfully created virtual power plant',
      messageType: SUCCESS
    })
  }

  useEffect(() => {
    if (vppId) {
      vppService.getVppDetails(vppId, _.get(props.currentUser, 'account_id', ''))
        .then(response => {
          setVppDetails(response || {})
        })
        .catch(error => {
          if (error.status === 404) {
            setNotFound(true)
          } else {
            errorCb(MessageType.INVALID_VPP)
          }
        })

    }
  }, [props.currentUser, vppId])

  const handleDelete = () => {
    setPopup(true)
  }

  const handleAck = () => {
    setLoading(true)
    vppService.deleteVpp(vppId, _.get(props.currentUser, 'account_id', ''))
      .then((response) => {
        setPopup(false)
        successCb(true)
      })
      .catch(error => {
        errorCb(MessageType.SOMETHING_WENT_WRONG)
        setOpen(true)
        setMessageType(ERROR)
        setPopup(false)
      })
  }

  const renderCardContent = () => {
    return (
      <Box className={classes.container}>
        <Box className={classes.formContainer}>{<VppForm {...props} isEdit={isEdit} vppDetails={vppDetails} isViewOnly={props.isViewOnly} errorCb={errorCb} successCb={successCb} />}</Box>
      </Box>
    )
  }

  const renderPopupContent = () => {
    return (
      <Box className={classes.popWrapper}>
        <Typography className={classes.popText}>
          Are you sure you want to delete this Virtual Power Plant?
        </Typography>
        <Box className={classes.buttonGroup}>
          <AppButton text='Yes' className={classes.ackButton} onClick={handleAck} />
          <AppButton text='No' fill={false} className={classes.ackButton} onClick={() => setPopup(false)} />
        </Box>
      </Box>
    )
  }

  const renderBreadCrumbValue = () => {
    let nav = []
    if (programId) {
      let obj = {}
      obj[_.get(props.programDetails, 'program_name_admin_ui', '')] = `/programs/${programId}`
      nav = [{ 'Home': '/' }, { 'Programs': '/programs' }, obj, { 'Virtual Power Plants': programId ? `/programs/${programId}/vpp` : '/vpp' }]
    } else {
      nav = [{ 'Home': '/' }, { 'Virtual Power Plants': programId ? `/programs/${programId}/vpp` : '/vpp' }]
    }

    if (isEdit) {
      if (props.isViewOnly) {
        nav.push({ 'View Virtual Power Plant': '' })
      } else {
        nav.push({ 'Edit Virtual Power Plant': '' })
      }
    } else {
      nav.push({ 'Create New Virtual Power Plant': '' })
    }

    return nav
  }

  return (
    <Box>
      {notFound ? <Error404 /> :
        <>
          <Breadcrumb value={renderBreadCrumbValue()} />
          <Box className={classes.headerWrapper}>
            <Typography className={classes.title}>{isEdit ? `${props.isViewOnly ? 'View' : 'Edit'} Virtual Power Plant` : 'Create New Virtual Power Plant'}</Typography>
            {isEdit && !props.isViewOnly && <OutlinedButton label='Delete this virtual power plant' onClick={handleDelete} />}
          </Box>
          <Cards className={classes.cardWrapper} children={renderCardContent()} />
          <DisplayMessage open={open} message={message} messageType={messageType} handleClose={() => setOpen(false)} />
          <Popup
            open={showPopup}
            handleClose={() => setPopup(false)}
            content={renderPopupContent()}
          />
          <Loader loading={loading} />
        </>
      }
    </Box>
  )
}

const mapStateToProps = ({ programs, auth }) => {
  const { stateList, programDetails } = programs
  const { currentUser, accountId, isAdmin, isViewOnly } = auth
  return { stateList, currentUser, accountId, isAdmin, programDetails, isViewOnly }
}

export default connect(mapStateToProps, {})(CreateVpp)
